import { ActivatedRouteSnapshot, MaybeAsync, RedirectCommand, Resolve, RouterStateSnapshot } from "@angular/router";
import { IQuickNavSearchTypeAndInfo } from "../../core/models/quick-nav.model";
import { Injectable } from "@angular/core";
import { QuickNavApiService } from "../services/quick-nav-api.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class QuickNavResolver implements Resolve<IQuickNavSearchTypeAndInfo[]> {
    private lastResolvedDate?: Date;
    private searchTypeAndInfo: BehaviorSubject<IQuickNavSearchTypeAndInfo[]> = new BehaviorSubject<IQuickNavSearchTypeAndInfo[]>([]);
    private searchTypeAndInfo$ = this.searchTypeAndInfo.asObservable();

    private MAX_AGE_MILLISECONDS: number = 5 * 60 * 1000;

    constructor(private quickNavApiService: QuickNavApiService){        
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IQuickNavSearchTypeAndInfo[]> {
        const curDate: Date = new Date();
        if( !this.lastResolvedDate || (curDate.getTime() - this.lastResolvedDate.getTime() > this.MAX_AGE_MILLISECONDS)){
            console.log(`Going to fetch QuickNav settings. Last resolved date: ${this.lastResolvedDate}`);
            this.quickNavApiService.getSearchInfo().subscribe((res) => {
                // console.log(`Got quick nav info response: ${JSON.stringify(res)}`);
                if( res?.Success ){                    
                    const arrSearchInfo: IQuickNavSearchTypeAndInfo[] = [];
                    res.SearchInfoList.forEach(x => arrSearchInfo.push(x));
                    this.searchTypeAndInfo.next(arrSearchInfo);
                    this.lastResolvedDate = new Date();
                }
            });
        } else {
            console.log(`Last resolved date: ${this.lastResolvedDate}. Using cached settings`);
        }
        return this.searchTypeAndInfo$;
    }
}